import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Chart } from '../models';

@Component({
  selector: 'max-maxis-chart-modal',
  templateUrl: './maxis-chart-modal.component.html',
  styleUrls: ['./maxis-chart-modal.component.scss']
})
export class MaxisChartModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MaxisChartModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  actions: { display: string, action: string }[];
  rangeColor: string = "#000000";
  hideOwnerInfo: boolean = false;
  hideChartId: boolean = false;
  hideUpdatedInfo: boolean = false;
  chart: Chart;
  owner: any;
  gridHeight = 400;
  gridWidth = 390;
  hideFilters = false;
  titleFontSize = 24;
  descFontSize = 16;
  gridColumnWidth = 100;
  gridFontSize = 16;
  shortenCategories = false;
  hideLegend = false;
  islightTheme: boolean = false;
  height: 540;
  width: 500;
  showValuesOnSeries = false;

  ngOnInit(): void {
    this.actions = this.data.actions;
    this.rangeColor = this.data.rangeColor;
    this.hideOwnerInfo = this.data.hideOwnerInfo;
    this.hideChartId = this.data.hideChartId;
    this.hideUpdatedInfo = this.data.hideUpdatedInfo;
    this.chart = this.data.chart;
    this.owner = this.data.owner;
    this.gridHeight = Math.round(this.data.dialogHeight * .6);
    this.gridWidth = Math.round(this.data.dialogWidth * .95);
    this.hideFilters = this.data.hideFilters;
    this.titleFontSize = this.data.titleFontSize;
    this.descFontSize = this.data.descFontSize;
    this.gridColumnWidth = this.data.gridFontSize;
    this.gridFontSize = this.data.gridFontSize;
    this.shortenCategories = this.data.shortenCategories;
    this.hideLegend = this.data.hideLegend;
    this.islightTheme = this.data.islightTheme;
    this.height = this.data.dialogHeight;
    this.width = this.data.dialogWidth;
    this.showValuesOnSeries = this.data.showValuesOnSeries;
    console.log('inited', this.height, this.width);
  }

  close(){
    this.dialogRef.close();
  }
}
